////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useRouteMatch } from 'react-router'
import styled from 'styled-components'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import { articleLifeManagerActionCreators } from '../../../../../store/actions'
import ArticleDatePicker from '../ArticleDatePicker'

/////////STYLED/////////
const ModifyAddStartWithDepositActionWrapper = styled.div``
/////////STYLED/////////
// [63]_g): MODIFY ADD START DEPOSIT

const ModifyAddStartWithDepositAction = (props) => {
	const match = useRouteMatch()

	const { translations, articleLifeManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			articleLifeManager: state.articleLifeManager,
		}),
		shallowEqual
	)

	const actionsArticleLifeManager = bindActionCreators(articleLifeManagerActionCreators, useDispatch())

	const [dateToModify, setDateToModify] = useState(new Date())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleChangeDate = (date) => {
		setDateToModify(new Date(date))
	}

	const handleValidate = () => {
		actionsArticleLifeManager.updateStartDepositAction(match.params.id, moment(dateToModify).add(10, 'minutes').toDate())
		handleCloseDatePicker()
	}

	const handleCloseDatePicker = () => {
		props.action.close()
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (props.action?.item?.dateToModify) if (props.action.show) handleChangeDate(new Date(props.action.item.dateToModify))
	}, [props.action.show])

	useEffect(() => {
		if (articleLifeManager?.isUpdate) props.action.close()
	}, [articleLifeManager?.isUpdate])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ModifyAddStartWithDepositActionWrapper>
			<ArticleDatePicker
				showModal={props.action.show}
				date={dateToModify}
				handleValidate={handleValidate}
				handleClose={handleCloseDatePicker}
				handleChangeDate={handleChangeDate}
				title={translations['modal__itemRef__timeline_action_consignment_startDate_edit_title']}
				priorLimit={props.action?.item?.dateLimit}
			/>
		</ModifyAddStartWithDepositActionWrapper>
	)
}

ModifyAddStartWithDepositAction.propTypes = {}

ModifyAddStartWithDepositAction.defaultPropTypes = {}

export default ModifyAddStartWithDepositAction
